module.exports = __webpack_public_path__ + "img/1.51c2c14d.png";